<div>
    <button (click)="executeQuerry()" [disabled]="HTML_HttpRequestInProgress">Execute Querry</button>
</div>
<div>

    <textarea id="queryTextArea"
        [(ngModel)]="HTML_TextEditer" 
        (keydown)="onKeyDown($event)" 
        (keyup)="onKeyUp($event)"
        [disabled]="HTML_HttpRequestInProgress"
        class="text-area">
    </textarea>
    
    
    <cdk-virtual-scroll-viewport itemSize="50" 
        *ngIf="HTML_ArrayValueAutoCompletion?.length > 0"
        id="myInputautocomplete-list" 
        class="autocomplete-items v-box" 
        [style.top.px]="HTML_caretPositionY"
        [style.left.px]="HTML_caretPositionX">
        <div *cdkVirtualFor="let item of HTML_ArrayValueAutoCompletion; let i = index" 
            (click)="insertValue(item)" >
            {{item}}
            <!-- <input type="text" value="item" id="completion-{{i}}"> -->
        </div>
    </cdk-virtual-scroll-viewport>
    
    <!--
    <div *ngIf="HTML_ArrayValueAutoCompletion?.length > 0" id="myInputautocomplete-list" class="autocomplete-items"
        [style.top.px]="HTML_caretPositionY" [style.left.px]="HTML_caretPositionX">
        <div *ngFor="let item of HTML_ArrayValueAutoCompletion; let i = index" (click)="insertValue(item)">
            {{item}}
        </div>
    </div>
    -->
</div>

<ng-container *ngIf="HTML_HttpRequestInProgress">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>

<app-custom-mat-list #ArmaList></app-custom-mat-list>